export default __webpack_public_path__ + "static/media/x.1482d22a.svg";